var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 7.5C32.5 6.11929 31.3807 5 30 5C28.6193 5 27.5 6.11929 27.5 7.5V31.4645L19.2678 23.2322C18.2915 22.2559 16.7085 22.2559 15.7322 23.2322C14.7559 24.2085 14.7559 25.7915 15.7322 26.7678L28.2322 39.2678C29.2085 40.2441 30.7915 40.2441 31.7678 39.2678L44.2678 26.7678C45.2441 25.7915 45.2441 24.2085 44.2678 23.2322C43.2915 22.2559 41.7085 22.2559 40.7322 23.2322L32.5 31.4645V7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 35C8.88071 35 10 36.1193 10 37.5V47.5C10 48.163 10.2634 48.7989 10.7322 49.2678C11.2011 49.7366 11.837 50 12.5 50H47.5C48.163 50 48.7989 49.7366 49.2678 49.2678C49.7366 48.7989 50 48.163 50 47.5V37.5C50 36.1193 51.1193 35 52.5 35C53.8807 35 55 36.1193 55 37.5V47.5C55 49.4891 54.2098 51.3968 52.8033 52.8033C51.3968 54.2098 49.4891 55 47.5 55H12.5C10.5109 55 8.60322 54.2098 7.1967 52.8033C5.79018 51.3968 5 49.4891 5 47.5V37.5C5 36.1193 6.11929 35 7.5 35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b92441d21992fd178d6fa932e691dea4.svg";
export { ForwardRef as ReactComponent };